import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LandingPageRoutes from "./landing_page/routes/LandingPageRoutes";
import Login from "./page/Login";
import RegisterPage from "./page/RegisterPage";
import MerchantRoutes from "./merchant_dashboard/routes/MerchantRoutes";
import ForgotPassword from "./page/ForgotPassword";
import ResetPasswordPage from "./page/ResetPasswordPage";
import AdminRoutes from "./admin/routes/AdminRoutes";

const App = () => {
  const router = createBrowserRouter([
    ...LandingPageRoutes,
    ...MerchantRoutes,
    ...AdminRoutes,
    {
      path: "/login",
      element: <Login />,
    },

    {
      path: "/forgot-password",
      element: <ForgotPassword />,
    },
    {
      path: "/reset-password",
      element: <ResetPasswordPage />,
    },

    {
      path: "/register",
      element: <RegisterPage />,
    },
  ]);
  return <RouterProvider router={router} />;
};

export default App;
